import * as t from "io-ts";

export type IAddressCountry = Readonly<{
    url: string;
    printable_name: string;
    iso_3166_1_a3: string;
    iso_3166_1_numeric: string;
    name: string;
    display_order: number;
    is_shipping_country: boolean;
}>;

export type IAddressState = Readonly<{
    code: string;
    name: string;
}>;

const BaseAddress = t.readonly(
    t.type({
        title: t.string,
        first_name: t.string,
        last_name: t.string,
        line1: t.string,
        line2: t.string,
        line4: t.string,
        state: t.string,
        postcode: t.string,
        country: t.string,
        phone_number: t.string,
    }),
);

export const Address = t.readonly(
    t.intersection([
        BaseAddress,
        t.type({
            url: t.string,
        }),
    ]),
);

export type IAddress = t.TypeOf<typeof Address>;

export const BillingAddress = t.readonly(
    t.intersection([
        BaseAddress,
        t.type({
            id: t.number,
            search_text: t.string,
        }),
    ]),
);

export type IBillingAddress = Readonly<{
    billing_addr_is_shipping_addr: boolean;
    billing_first_name: string;
    billing_last_name: string;
    billing_line1: string;
    billing_line2: string;
    billing_line4: string;
    billing_state: string;
    billing_postcode: string;
    billing_country: string;
    billing_phone_number: string;
}>;

export type IBillingAddressErrorSet = Readonly<{
    non_field_errors: readonly string[];
    billing_first_name: readonly string[];
    billing_last_name: readonly string[];
    billing_line1: readonly string[];
    billing_line2: readonly string[];
    billing_line4: readonly string[];
    billing_state: readonly string[];
    billing_postcode: readonly string[];
    billing_country: readonly string[];
    billing_phone_number: readonly string[];
}>;

export const ShippingAddress = t.readonly(
    t.intersection([
        BillingAddress,
        t.type({
            notes: t.string,
        }),
    ]),
);

export type IShippingAddress = Readonly<{
    shipping_first_name: string;
    shipping_last_name: string;
    shipping_line1: string;
    shipping_line2: string;
    shipping_line4: string;
    shipping_state: string;
    shipping_postcode: string;
    shipping_country: string;
    shipping_phone_number: string;
}>;
